var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeTrilha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11424_23540)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9892 38.7124C11.5311 38.7124 3.04346 42.9562 3.04346 48.1853C3.04346 52.4291 8.61349 56.0098 16.3054 57.2224V63.3418L23.8837 55.7635L16.3054 48.1853V53.3574C10.3376 52.2965 6.8326 49.7577 6.8326 48.1853C6.8326 46.177 12.5921 42.5015 21.9892 42.5015C31.3862 42.5015 37.1457 46.177 37.1457 48.1853C37.1457 49.5683 34.3797 51.766 29.5674 52.9785V56.8624C36.2553 55.4036 40.9349 52.0691 40.9349 48.1853C40.9349 42.9562 32.4472 38.7124 21.9892 38.7124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2358 -0.0439453C12.2739 -0.0439453 4.2168 8.01313 4.2168 17.9751C4.2168 31.4893 22.2358 51.439 22.2358 51.439C22.2358 51.439 40.2548 31.4893 40.2548 17.9751C40.2548 8.01313 32.1978 -0.0439453 22.2358 -0.0439453ZM22.236 24.4106C18.6837 24.4106 15.8006 21.5275 15.8006 17.9752C15.8006 14.4229 18.6837 11.5399 22.236 11.5399C25.7883 11.5399 28.6713 14.4229 28.6713 17.9752C28.6713 21.5275 25.7883 24.4106 22.236 24.4106Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11424_23540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 60.5769,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeTrilha);
export default __webpack_public_path__ + "static/media/IconeTrilha.4e773632581877fd02883ddc55b555bf.svg";
export { ForwardRef as ReactComponent };